export { default as StorageMaterialOrderSlot } from './StorageMaterialOrderSlot';
